import {defineMessages} from 'react-intl'

export const aiReviewsMessages = defineMessages({
  facilities: {
    id: 'facilities',
    defaultMessage: 'Facilities'
  },
  rooms: {
    id: 'rooms',
    defaultMessage: 'Rooms'
  },
  dining: {
    id: 'dining',
    defaultMessage: 'Dining'
  },
  service: {
    id: 'service',
    defaultMessage: 'Service'
  },
  cleanliness: {
    id: 'cleanliness',
    defaultMessage: 'Cleanliness'
  },
  location: {
    id: 'location',
    defaultMessage: 'Location'
  },
  aiPoweredSummarySectionTitle: {
    id: 'reviews.whatGuestsThink',
    defaultMessage: 'What guests think'
  },
  aiPoweredSummarySectionDescription: {
    id: 'reviews.aiPoweredSummarySectionDescription',
    defaultMessage: 'AI-generated summary based on recent guest reviews'
  },
  aiPoweredReviewInsightsTitle: {
    id: 'reviews.aiPoweredReviewInsightsTitle',
    defaultMessage: 'Guest review insights'
  },
  aiPoweredReviewInsightsDescription: {
    id: 'reviews.aiPoweredReviewInsightsDescription',
    defaultMessage:
      'We use AI to summarize recent guest reviews to give you the most up-to-date info at a glance (accuracy may vary).'
  },
  aiPoweredReviewGuestInsights: {
    id: 'reviews.aiPoweredReviewGuestInsights',
    defaultMessage: 'Guest insights'
  },
  overall: {
    id: 'reviews.overall',
    defaultMessage: 'Overall'
  },
  guestInsightsBasedOnRealReviews: {
    id: 'reviews.guestInsightsBasedOnRealReviews',
    defaultMessage: 'Guest insights based on real reviews'
  },
  relatedGuestReviews: {
    id: 'reviews.relatedGuestReviews',
    defaultMessage: 'Related guest reviews'
  },
  wasThisHelpful: {
    id: 'reviews.wasThisHelpful',
    defaultMessage: 'Was this helpful?'
  },
  thanksForLettingUsKnow: {
    id: 'reviews.thanksForLettingUsKnow',
    defaultMessage: 'Thanks for letting us know!'
  }
})
